const DEFAULT_LEGAL_ROUTES = {
    privacyPolicy: '/privacy-policy/',
    termsAndConditions: '/terms-and-conditions/',
    cookiePolicy: '/cookie-policy/',
    complaintPolicy: '/complaints-policy/',
    cryptoRiskDisclosures: '/cryptocurrency-risk-disclosures/',
}

export const footerConfig = {
    legalLinks: [
        {
            title: "footer.privacy_policy",
            href: DEFAULT_LEGAL_ROUTES.privacyPolicy,
        },
        {
            title: "footer.terms_conditions",
            href: DEFAULT_LEGAL_ROUTES.termsAndConditions,
        },
        {
            title: "footer.cookie_policy",
            href: DEFAULT_LEGAL_ROUTES.cookiePolicy,
        },
        {
            title: "footer.complaints_policy",
            href: DEFAULT_LEGAL_ROUTES.complaintPolicy,
        },
        {
            title: "footer.cryptocurrency_risk_disclosures",
            href: DEFAULT_LEGAL_ROUTES.cryptoRiskDisclosures,
        },
    ],
    copyright: 'footer.copyright',
    footerItems: [
        'footer.Banxe_LTD_is',
        'footer.Banxe_is_a',
        'footer.Tompay_LTD_is',
        'footer.The_services_offered',
        'footer.Cryptocurrency_services',
        'footer.sia_paybis',
    ],
} as const
